<template>
  <el-upload
    :action="href"
    :headers="headers"
    :accept="accept"
    :data="params"
    :show-file-list="showFileList"
    :on-success="handleUploadSuccess"
    :before-upload="beforeUpload"
    :multiple="multiple"
    :limit="limit"
    :on-exceed="onExceed"
    :file-list="fileList"
    :disabled="isDisabled"
  >
    <el-button size="small" type="primary">
      <slot>
        Upload
      </slot>
    </el-button>
  </el-upload>
</template>

<script>
import api from "@/api";
export default {
  name: "AppUploader",
  props: {
    url: {
      type: String,
      required: true
    },
    params: {
      type: Object
    },
    accept: {
      type: String,
      default: "*"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number
    },
    fileList: {
      type: Array
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      href: new URL(this.url, api.baseUrl).href,
      headers: {
        Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
        "X-Requested-With": "XMLHttpRequest"
      }
    };
  },
  methods: {
    handleUploadSuccess(res, file, fileList) {
      this.$emit("uploadSuccess", res, file, fileList);
    },
    beforeUpload() {
      this.$emit("beforeUpload");
    },
    getFilename(filename) {
      let s = filename.split(".");
      s.pop();
      return s.join("");
    },
    onExceed(files, fileList) {
      this.$emit("onExceed", files, fileList);
      this.$notify({
        type: "error",
        message: `Files attached exceeded the limit (${this.limit})`,
        position: "bottom-right"
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
